// extracted by mini-css-extract-plugin
module.exports = {"block":"block__3Krqc","block__label":"block__label__2b8Iy"};